import React from 'react';
import { autoArrangeLayout, showArrangeOptions, autoResizeComponents } from './DashboardAutoArrange';
import { getCompactTypeLabel } from '../utils/dashboardHelpers';
import { showSuccessMessage, showErrorMessage } from '../utils/dashboardMessageUtils';

const DashboardToolbar = ({
  editMode,
  isSavingLayout,
  dashboardTemplate,
  layouts,
  setLayouts,
  compactType,
  saveAndExit,
  cancelChanges,
  exitWithoutSaving,
  openOptionsModal,
  addNewChart,
  toggleCompactType,
  openAlarmManagement,
  // 🔄 Undo/Redo 기능 추가
  canUndo,
  canRedo,
  undo,
  redo,
  undoStack,
  redoStack,
  // 그리드 세분화
  gridColumns,
  onGridColumnsChange
}) => {

  if (!editMode) return null;

  return (
    <div className="dashboard-controls">
      {/* 편집 모드 버튼들 - 항상 동일한 버튼 표시 */}
      <button 
        className="save-btn"
        onClick={saveAndExit}
        disabled={isSavingLayout}
        title="변경사항을 저장하고 편집 모드를 종료합니다"
      >
        {isSavingLayout ? '저장 중...' : '저장 후 완료'}
      </button>
      
      <button 
        className="cancel-btn"
        onClick={cancelChanges}
        disabled={isSavingLayout}
        title="변경사항을 취소하고 원래 상태로 되돌립니다"
      >
        취소
      </button>
      
      <button 
        className="exit-without-save-btn"
        onClick={exitWithoutSaving}
        disabled={isSavingLayout}
        title="변경사항을 저장하지 않고 편집 모드를 종료합니다"
      >
        저장하지 않고 나가기
      </button>

      {/* 🔄 Undo/Redo 버튼 그룹 */}
      <div className="undo-redo-group">
        <button 
          className={`undo-btn ${!canUndo ? 'disabled' : ''}`}
          onClick={undo}
          disabled={!canUndo || isSavingLayout}
          title={canUndo ? 
            `실행 취소 (Ctrl+Z) - ${undoStack.length}개 작업 가능` : 
            '실행 취소 불가능'
          }
        >
          ⮪ 실행 취소
        </button>
        
        <button 
          className={`redo-btn ${!canRedo ? 'disabled' : ''}`}
          onClick={redo}
          disabled={!canRedo || isSavingLayout}
          title={canRedo ? 
            `다시 실행 (Ctrl+Y) - ${redoStack.length}개 작업 가능` : 
            '다시 실행 불가능'
          }
        >
          ⮫ 다시 실행
        </button>
      </div>
      
      {/* 디버그 패널 토글 버튼 제거: 시스템 헤더에만 배치 */}

      {/* 대시보드 옵션 편집 버튼 */}
      <button 
        className="dashboard-options-btn"
        onClick={openOptionsModal}
        title="대시보드 옵션 편집"
      >
        대시보드 옵션
      </button>
      
      {/* 알람 관리 버튼 - 숨김 처리 */}
      {/* <button
        className="alarm-management-btn"
        onClick={openAlarmManagement}
        title="알람 관리"
      >
        🔔 알람 관리
      </button> */}
      
      {/* 배경 이미지 설정 버튼 제거: 옵션 모달로 이동 */}
      
      {/* 새 차트 추가 버튼 */}
      <button 
        className="add-chart-btn"
        onClick={addNewChart}
        title="새 차트 추가"
      >
        차트 추가
      </button>
      
      {/* 자동 배치 토글 버튼 - 밀기 없음으로 고정 */}
      <button
        className="compact-type-btn"
        // onClick={toggleCompactType}  // 토글 기능 비활성화
        title="현재 모드: 밀기 없음"
      >
        밀기 없음
        {/* {getCompactTypeLabel(compactType)} */}
      </button>

      {/* 그리드 세밀도 선택 제거: 옵션 모달로 이동 */}
    </div>
  );
};

export default DashboardToolbar; 